import { axios } from '@Root/API'

export const getStatic = () => {
	return axios.get('get/funding-and-monitoring/student-course-session')
}
